import type { RetryStatus } from '@/api/retry-processor/mock';
import { Badge, type BadgeStatus } from '@/components/ui/badge';

// Domain retry status -> shared Badge status color (per index.css tokens):
//   retrying  = info (brand-navy)   succeeded = success (green)
//   exhausted = danger (red)        pending   = neutral (muted)
// Styling (mono/uppercase/square/color) lives entirely in the Badge atom now.
const STATUS_TO_BADGE: Record<RetryStatus, BadgeStatus> = {
	retrying: 'info',
	succeeded: 'success',
	exhausted: 'danger',
	pending: 'neutral',
};

const CHIP_LABELS: Record<RetryStatus, string> = {
	retrying: 'Retrying',
	succeeded: 'Succeeded',
	exhausted: 'Exhausted',
	pending: 'Pending',
};

export function StatusChip({ status }: { status: RetryStatus }) {
	return <Badge status={STATUS_TO_BADGE[status]}>{CHIP_LABELS[status]}</Badge>;
}
